"use strict";

var _ = require("underscore");
var moment = require("moment");

module.exports.formatDateFromJQueryDateUI = function formatDateFromJQueryDateUI(event) {
  if (event) {
    var selectedDay = event.selectedDay;
    var selectedMonth = event.selectedMonth;
    var selectedYear = event.selectedYear;
    var day = "";
    var month = "";
    var year = selectedYear.toString();

    if (selectedDay) {
      if (parseInt(selectedDay) < 10) {
        day = "0" + selectedDay;
      } else {
        day = selectedDay.toString();
      }
    }

    if (selectedMonth || selectedMonth === 0) {
      month = parseInt(selectedMonth) + 1;
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
    }

    // FORMAT YYYY-MM-DD
    return year + "-" + month + "-" + day;
  } else {
    return "";
  }
};

module.exports.formatDateToJQueryDateUI = function formatDateToJQueryDateUI(date) {
  return moment(date).format("DD MMM, YYYY");
};

/**
  Gets the period of time with the same duration as the given period,
  one month before, if the duration is less than or equal to a month,
  or one year before, if the duration is more than a month.
**/
module.exports.getRelativeComparisonRange = function(beginDate, endDate) {
  var dateFormat = "YYYY-MM-DD";

  var endDateComparison = "";
  var beginDateComparison = "";

  var beginDateMonth = moment(beginDate).month();
  var endDateMonth = moment(endDate).month();

  var areMonthsEqual = beginDateMonth === endDateMonth;

  if (areMonthsEqual) {
    beginDateComparison = moment(beginDate).subtract(1, "month").format(dateFormat);

    var lastDayOfMonth = moment(endDate).endOf("month").format(dateFormat);
    var isLastDayOfMonth = endDate == lastDayOfMonth;

    if (isLastDayOfMonth) {
      endDateComparison = moment(endDate).subtract(1, "month").endOf("month").format(dateFormat);
    } else {
      endDateComparison = moment(endDate).subtract(1, "month").format(dateFormat);
    }

  } else {
    var beginDateYear = moment(beginDate).year();
    var endDateYear = moment(endDate).year();

    var areYearsEqual = beginDateYear === endDateYear;

    endDateComparison = moment(endDate).subtract(1, "years").format(dateFormat);
    beginDateComparison = moment(beginDate).subtract(1, "years").format(dateFormat);
  }

  return {
    beginDate: beginDateComparison,
    endDate: endDateComparison
  };
};

/**
  Gets the period of time of the same duration as the given period,
  immediately before it.
**/
module.exports.getImmediateComparisonRange = function(start, end) {
  let periodStart = moment(start).startOf("day");
  let periodEnd = moment(end).endOf("day");

  let comparisonStart;
  let justBeforeStart = moment(periodStart).subtract(1);
  let justAfterEnd = moment(periodEnd).add(1);

  let monthDiff = justAfterEnd.diff(periodStart, "months", true);

  if (Number.isInteger(monthDiff)) {
    comparisonStart = moment(periodStart).subtract(monthDiff, "months");
  } else {
    let dayDiff = justAfterEnd.diff(periodStart, "days");

    comparisonStart = moment(periodStart).subtract(dayDiff, "days");
  }

  return {
    startDate: comparisonStart,
    endDate: justBeforeStart
  };
};

module.exports.formatNumberToDays = function(value) {
  let days;

  if (Math.abs(value) > 1) {
    days = "dias"
  } else {
    days = "dia"
  }

  return `${value} ${days}`;
}



// WEBPACK FOOTER //
// ./app/util/formatter/date.js